module.exports = __webpack_public_path__ + "static/img/tresguerras.d1b9b99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tresguerras.svg
// module id = lIzc
// module chunks = 1